import React, { useState, useEffect } from 'react';
import { getSevisStatuses, createI20 } from '../utils/api';
import { mapErrorMessage } from '../utils/errorMapping';
import './_Modal.css';

const CreateI20Modal = ({ studentId, onClose, onI20Created }) => {
    const [sevisNumber, setSevisNumber] = useState('');
    const [status, setStatus] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [file, setFile] = useState(null);
    const [statuses, setStatuses] = useState({});
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchStatuses = async () => {
            try {
                const response = await getSevisStatuses();
                setStatuses(response.data);
            } catch (error) {
                setError('An error occurred while fetching SEVIS statuses.');
            }
        };
        fetchStatuses();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!sevisNumber || !status || !startDate || !endDate || !file) {
            setError('Please fill out all fields.');
            return;
        }

        const formData = new FormData();
        formData.append('sevis_number', sevisNumber);
        formData.append('status', status);
        formData.append('start_date', startDate);
        formData.append('end_date', endDate);
        formData.append('file', file);

        try {
            await createI20(studentId, formData);
            onI20Created();
            onClose();
        } catch (error) {
            setError(mapErrorMessage(error.message));
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="modal-close" onClick={onClose}>X</button>
                <h2>Upload I-20</h2>
                {error && <p className="error">{error}</p>}
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <input
                            type="text"
                            placeholder="SEVIS Number"
                            value={sevisNumber}
                            onChange={(e) => setSevisNumber(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <select value={status} onChange={(e) => setStatus(e.target.value)}>
                            <option value="">Select a status</option>
                            {Object.entries(statuses).map(([key, value]) => (
                                <option key={key} value={key}>{value}</option>
                            ))}
                        </select>
                    </div>
                    <div className="form-group">
                         <label>Start Date</label>
                        <input
                            type="date"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                         <label>End Date</label>
                        <input
                            type="date"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <input
                            type="file"
                            onChange={(e) => setFile(e.target.files[0])}
                        />
                    </div>
                    <div className="actions-centered">
                        <button type="button" onClick={onClose} className="cancel-button text-button">Cancel</button>
                        <button type="submit" className="submit-button text-button">Upload</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CreateI20Modal;